<!-- =========================================================================================
    File Name: Invoice.vue
    Description: Invoice Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div id="component-find-client">

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/3 w-full">
                <span>
                    Code Postal
                </span>
      </div>
      <div class="vx-col sm:w-2/3 w-full">
        <vs-input class="w-full" v-model="searchPostalCode" label="Exemple: J9A3B8" name="searchPostalCode" v-validate="{regex: '^([a-zA-Z][0-9][a-zA-Z][0-9][a-zA-Z][0-9])$' }"/>

        <span class="text-danger text-sm" v-if="searchPostalCode.length >= 6" v-show="errors.has('searchPostalCode')">
            Le format est invalide
        </span>

      </div>
    </div>
    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/3 w-full">
                <span>

                </span>
      </div>
      <div class="vx-col sm:w-2/3 w-full">
        <vs-button @click="promptResultOpen = true" color="success" :disabled="!isValidPostalCode">Rechercher</vs-button>
      </div>
    </div>

    <vs-prompt
      :active.sync="promptResultOpen"
      buttonAccept="false"
      @cancel="promptResultOpen = false"
      @close="promptResultOpen = false">


      <div class="con-exemple-prompt">

        <vs-table :data="postalCodeSearchResult" pagination :maxItems="9" search>

          <template slot="thead">
            <vs-th sort-key="firstName">ID Citoyen</vs-th>
            <vs-th sort-key="firstName">Prénom</vs-th>
            <vs-th sort-key="lastName">Nom</vs-th>
            <vs-th sort-key="addressStreet">Addresse</vs-th>
            <vs-th sort-key="city">Ville</vs-th>
            <vs-th></vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
              <vs-td :data="tr.idCard">
                {{tr.idCard}}
              </vs-td>
              <vs-td :data="tr.firstName">
                {{tr.firstName}}
              </vs-td>
              <vs-td :data="tr.lastName">
                {{tr.lastName}}
              </vs-td>
              <vs-td :data="tr.addressStreet">
                <span v-if="tr.addressApp"> {{tr.addressApp}} , </span> {{tr.addressNo}} {{tr.addressStreet}}
              </vs-td>
              <vs-td :data="tr.city">
                {{tr.city}}
              </vs-td>
              <vs-td :data="tr.city">
                <vs-button @click="selectClient(tr)">Sélectioner</vs-button>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
    </vs-prompt>
  </div>
</template>

<script>
  import VueSlider from 'vue-slider-component'
  import 'vue-slider-component/theme/antd.css'
  import firebase from 'firebase'

  export default {
    components: {
      VueSlider
    },
    data ()
    {
      return {
        mounted: false,

        searchPostalCode: '',

        promptResultOpen:       false,
        postalCodeSearchResult: [],
      }
    },
    computed:   {
      isValidPostalCode ()
      {
        return this.searchPostalCode.length === 6 && !this.errors.has('searchPostalCode')
      },
      activeUserInfo ()
      {
        return this.$store.state.AppActiveUser
      },
      cityConfig ()
      {
        return this.$store.state.cityConfig
      },
    },
    methods:    {

      filterPostalCode (postalCode)
      {
        postalCode = postalCode.toUpperCase()
        postalCode = postalCode.replace(' ', '')

        return postalCode
      },
      init ()
      {
        this.mounted = true
      },
      selectClient (client)
      {
        this.$emit('clientSelected', client)

        this.promptResultOpen = false
      },
    },
    watch:      {
      '$store.state.cityConfig' ()
      {
        this.init()
      },
      searchPostalCode ()
      {
        this.$emit('streetsAutoComplete', [])

        this.$validator.validate('searchPostalCode').then(res => {

          this.searchPostalCode = this.filterPostalCode(this.searchPostalCode)

          if (!res || this.searchPostalCode.length !== 6)
          {
            console.log('invalid postal code')
            return
          }

          this.$emit('validPostalCode', this.searchPostalCode)

          console.log('city', this.cityConfig.id)
          firebase
            .firestore()
            .collection('clients')
            .where('cityID', '==', this.cityConfig.id)
            .where('postalCode', '==', this.searchPostalCode)
            .orderBy('addressStreet')
            .get()
            .then(snapshot => {
              const streets = []
              const results = []
              snapshot.forEach(doc => {
                const data = doc.data()
                data.id    = doc.id

                results.push(data)
              })

              results.forEach(result => {

                if (!streets.includes(result.addressStreet))
                {
                  streets.push(result.addressStreet)
                }
              })

              this.$emit('streetsAutoComplete', streets)

              this.postalCodeSearchResult = results
              this.promptResultOpen       = true
            })
        })
      },
    },
    mounted ()
    {
      this.init()
    }
  }
</script>

<style lang="scss">
  .vs-dialog {
    max-width: 80% !important;
  }
</style>
